import { UseSignaturePaymentENTParams } from '../../../../../../../../hooks/fetchers/useSignaturePaymentENT/useSignaturePaymentENT.types';
import { BaseResponse } from '../../../../../../../../types/api/api.types';
import { Code } from '../../../../../../../../types/models/code/code.types';
import { AUTH_ENDPOINTS } from '../../../../../../../../utils/api/endpoints/authEndpoints';
import { CODES_ENDPOINTS } from '../../../../../../../../utils/api/endpoints/codesEndpoints';
import { PAYMENT_ENDPOINTS } from '../../../../../../../../utils/api/endpoints/paymentEndpoints';
import { RegisterNAFProspectQueryParams, RegisterNAFProspectQueryResponse } from './ProspectPaymentForm.types';

const PREFIX = '[registerNAFProspectQuery]';

export const REGISTER_NAF_PROSPECT_QUERY_KEY = 'REGISTER_NAF_PROSPECT';

export const registerNAFProspectQuery = async (data: RegisterNAFProspectQueryParams) => {
  console.log(PREFIX, `Adding NAF codes to company...`);

  const response = await AUTH_ENDPOINTS.fieldsOfActivityProspect(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Added NAF codes to company.`);
  return json as RegisterNAFProspectQueryResponse;
};

const CODE_PREFIX = '[checkCodeQuery]';

export const CHECK_CODE_QUERY_KEY = 'CHECK_CODE';

export const checkCodeQuery = async (code: string) => {
  console.log(CODE_PREFIX, `Checking code validity...`);

  const response = await CODES_ENDPOINTS.check(code);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(CODE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(CODE_PREFIX, `Checked code validity.`);
  return json as Code;
};


const SIMULATE_PAYMENT_PREFIX = '[simulatePaymentQuery]';

export const SIMULATE_PAYMENT_QUERY_KEY = 'SIMULATE_PAYMENT';

export const simulatePaymentQuery = async (data: UseSignaturePaymentENTParams) => {
  console.log(SIMULATE_PAYMENT_PREFIX, `Simulating a payment...`);

  const response = await PAYMENT_ENDPOINTS.simulate(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SIMULATE_PAYMENT_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SIMULATE_PAYMENT_PREFIX, `Simulated a payment.`);
  return json as BaseResponse;
};

const VALIDATE_PAYMENT_PREFIX = '[validatePaymentQuery]'

export const VALIDATE_PAYMENT_QUERY_KEY = 'VALIDATE_PAYMENT'

export const validatePaymentQuery = async (data: any) => {
  console.log(VALIDATE_PAYMENT_PREFIX, `Requesting company account update...`);
  const response = await PAYMENT_ENDPOINTS.validatePaymentENT(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(VALIDATE_PAYMENT_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(VALIDATE_PAYMENT_PREFIX, `Received company account update response.`);
  return json as BaseResponse;
}